var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Utils, PropertyConverters, Components, CustomElementUtils } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
const SVG = /^\s*<svg\s/;
const FA = /^fa(b|r|s|l|d|t|-brands|-solid|-regular|-light|-thin|-duotone)?\s+fa-/;
const FA_CDN = { url: "https://kit.fontawesome.com/4922589c3c.js", crossOrigin: true };
const LNI = /^lni\s+lni-/;
const LNI_CDN = "https://cdn.lineicons.com/2.0/LineIcons.css";
const COREUI = /^ci[dlsbf]-/;
const COREUI_CDN = "https://unpkg.com/@coreui/icons/css/all.min.css";
const MATERIAL = /^material-icons?\s+([\w]+)/;
//const MATERIAL_CDN = "https://fonts.googleapis.com/icon?family=Material+Icons";
const MATERIAL_SYMBOLS = /^material(-symbols?)?\s+([\w]+)/;
// TODO: put this url in a css variable and use it across the site (eventually)
const MATERIAL_SYMBOLS_CDN = "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200";
const URL = /^(https?:\/\/|\/\/)?.+\.(webp|svg|gif|png|jpe?g)$/;
const iconImportMemoizer = [];
function importConditionally(cssClassName, url, sha, crossOrigin, js) {
    if (iconImportMemoizer.indexOf(cssClassName) >= 0) {
        return Promise.resolve();
    }
    iconImportMemoizer.push(cssClassName);
    // this is the heavy part, be sure to call it just once (thus the memoizer)
    if (Utils.Css.isClassDefined(cssClassName)) {
        return Promise.resolve();
    }
    return js ? CustomElementUtils.importjs(url, sha, crossOrigin) : CustomElementUtils.importcss(url, sha, crossOrigin);
}
function getIconMarkup(icon) {
    return new Promise((resolve, reject) => {
        // null or empty
        if (Utils.isNullOrEmpty(icon)) {
            reject('No icon provided');
        }
        // svg?
        else if (SVG.test(icon)) {
            resolve(icon);
        }
        // font-awesome?
        else if (FA.test(icon)) {
            importConditionally("fa", FA_CDN.url, undefined, FA_CDN.crossOrigin, true).then(_ => {
                resolve(`<i class="${icon}"></i>`);
            }, e => reject(e));
        }
        // explicit material symbols?
        else if (MATERIAL_SYMBOLS.test(icon)) {
            importConditionally("material-symbols", MATERIAL_SYMBOLS_CDN).then(_ => {
                const regExcArray = MATERIAL_SYMBOLS.exec(icon), ligature = regExcArray[2], rest = icon.substring(regExcArray[0].length);
                resolve(`<i class="material-symbols-outlined${rest}">${ligature}</i>`);
            }, e => reject(e));
        }
        // explicit material icons? (switch to the new material-symbols anyway)
        else if (MATERIAL.test(icon)) {
            importConditionally("material-icons", MATERIAL_SYMBOLS_CDN).then(_ => {
                const regExcArray = MATERIAL.exec(icon), ligature = regExcArray[1], rest = icon.substring(regExcArray[0].length);
                resolve(`<i class="material-icons${rest}">${ligature}</i>`);
            }, e => reject(e));
        }
        // line-icons?
        else if (LNI.test(icon)) {
            importConditionally('lni', LNI_CDN).then(_ => {
                resolve(`<i class="${icon}"></i>`);
            }, e => reject(e));
        }
        // coreui icons?
        else if (COREUI.test(icon)) {
            importConditionally('clb', COREUI_CDN).then(_ => {
                resolve(`<i class="${icon}"></i>`);
            }, e => reject(e));
        }
        // image url?
        else if (URL.test(icon)) {
            resolve(`<img src="${icon}" />`);
        }
        else {
            // assume material icon as default
            const parts = icon.trim().split(' ');
            const ligature = parts[0];
            const css = parts.length > 1 ? ' ' + parts.slice(1).join(' ') : '';
            resolve(`<i class="${PCSS}-icon${css}">${ligature}</i>`);
        }
    });
}
let PacemIconElement = class PacemIconElement extends Components.PacemElement {
    constructor() {
        super('', { hidden: 'true' });
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'icon':
                    this._setIcon();
                    break;
                case 'hide':
                    if (!val) {
                        // overrides the default `PacemElement` behavior:
                        // keep aria-hidden=true (to prevent screen readers from reading the ligatures)
                        this.aria.attributes.set('hidden', 'true');
                    }
                    break;
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._setIcon();
    }
    _setIcon(icon = this.icon) {
        getIconMarkup(icon).then(markup => {
            this.innerHTML = markup;
        }, _ => {
            this.innerHTML = '';
        });
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemIconElement.prototype, "icon", void 0);
PacemIconElement = __decorate([
    CustomElement({
        tagName: P + '-icon'
    })
], PacemIconElement);
export { PacemIconElement };
//}
